/** Shared TaskList props for subtask lists inside TaskGroupSubtasks. */
export const buildSharedTaskListProps = ({
  isSortable,
  duplicateOrderKeyTaskIds,
  plannedParentIds,
  waitingForParentIds,
  selectedSubtaskIds,
  setSelectedSubtaskIds,
  editingTaskId,
  setEditingTaskId,
  disableRowNavigate = false,
}) => ({
  isSortable,
  indentationType: 'detail',
  view: 'subtask',
  menuSurface: 'organize-detail',
  selectNewTask: true,
  selectedTaskIds: selectedSubtaskIds,
  onSelectionChange: setSelectedSubtaskIds,
  duplicateOrderKeyTaskIds,
  plannedParentIds,
  waitingForParentIds,
  editingTaskId,
  onStartEditing: setEditingTaskId,
  onStopEditing: () => setEditingTaskId(null),
  disableRowNavigate,
});
